import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IConfigAddPayload, IConfigUpdatePayload } from './config.interface';

@Injectable({
    providedIn: 'root',
})
export class ConfigService {
    private token!: string;
    private basePath = environment.interop.basePath;

    private listUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.administrative.configurations.list;

    public listDTUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.administrative.configurations.listDT;

    private storeURL =
        this.basePath +
        environment.interop.indoc.nomenclatoare.administrative.configurations.store;

    private updateUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.administrative.configurations.update;

    private httpOptions: any;

    constructor(private http: HttpClient) { }

    getListDT() {
        return this.http.get(this.listDTUrl, this.httpOptions);
    }

    storeEntry(payload: IConfigAddPayload) {
        return this.http.post(this.storeURL, payload, this.httpOptions);
    }

    updateEntry(payload: IConfigUpdatePayload) {
        return this.http.put(this.updateUrl, payload, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
